import { Pipe, PipeTransform } from '@angular/core';
import { IDocumentTypesDto } from 'app/main/pages/documents/dto/document-listing.dto';
import { IField, ISection } from '../document-type-settings.dto';
import { AdjustableColumns } from '../default-constants/document-type-settings.constants';

@Pipe({
  name: 'extractDocumentTypeSectionData',
  standalone: true,
})

export class ExtractDocumentTypeSectionDataPipe implements PipeTransform {

  constructor() {}

  transform(layoutSettings: IDocumentTypesDto, section: string, extractColumns: boolean = false): ISection | IField[] | undefined {
    if(extractColumns){
      return this.makeSavedColumnsAdjustable(layoutSettings?.sections.find(s => s.name === section)?.columns);
    } 
    return layoutSettings?.sections.find(s => s.name === section);
  }





  private makeSavedColumnsAdjustable(columns: IField[] | undefined): IField[] | undefined {
    const adjustableValues = Object.values(AdjustableColumns);
    return columns?.map((column) => ({
      ...column,
      is_adjustable: adjustableValues.includes(column.field_name as AdjustableColumns),
    }));
  }

}
